import React from 'react'
import PropTypes from 'prop-types'

import LineItemsDetailsContentPanel from './LineItemsDetailsContentPanel'
import LineItemsDetailsContentTable from './LineItemsDetailsContentTable'

export default class LineItemsDetailsContent extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape().isRequired,
    mode: PropTypes.string.isRequired,
    dateStr: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    lineItems: PropTypes.array.isRequired,
    workers: PropTypes.array.isRequired,
    allocations: PropTypes.shape().isRequired,
    onModeSelectorChanged: PropTypes.func.isRequired,
    onSelectedDayChanged: PropTypes.func.isRequired,
    onAllocationTimeChanged: PropTypes.func.isRequired
  }

  handleModeSelectorChanged = (mode) => {
    this.props.onModeSelectorChanged(mode)
  }

  handleSecletedDayChanged = (dateStr) => {
    this.props.onSelectedDayChanged(dateStr)
  }

  handleAllocationTimeChanged = (lineItem, worker, timeInMinutes) => {
    this.props.onAllocationTimeChanged(lineItem, worker, timeInMinutes)
  }

  render() {
    return (
      <div>
        <LineItemsDetailsContentPanel
          jobInfo={this.props.jobInfo}
          mode={this.props.mode}
          dateStr={this.props.dateStr}
          onModeSelectorChanged={this.handleModeSelectorChanged}
          onSelectedDayChanged={this.handleSecletedDayChanged} />
        <LineItemsDetailsContentTable
          loading={this.props.loading}
          lineItems={this.props.lineItems}
          mode={this.props.mode}
          workers={this.props.workers}
          allocations={this.props.allocations}
          onAllocationTimeChanged={this.handleAllocationTimeChanged} />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsDetailsContent.js